import { render, staticRenderFns } from "./AdminUsersNew.vue?vue&type=template&id=9f865032&"
import script from "./AdminUsersNew.vue?vue&type=script&lang=js&"
export * from "./AdminUsersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports